import { render, staticRenderFns } from "./JPopupOnlReport.vue?vue&type=template&id=2c3cc284&scoped=true"
import script from "./JPopupOnlReport.vue?vue&type=script&lang=js"
export * from "./JPopupOnlReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cc284",
  null
  
)

export default component.exports